import { faFilter as faFilterRegular } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { HtmlHTMLAttributes, ReactNode } from 'react';
import { usePopoverContext } from '../Popover/PopoverLogic';
import VoxelTooltipShort from '../Tooltip/VoxelTooltipShort';

export interface FilterChangeIconProps
  extends Omit<HtmlHTMLAttributes<HTMLDivElement>, 'title' | 'align'> {
  align?: 'left' | 'right' | 'center' | 'justify' | 'char';
  title: ReactNode;
  tooltip?: string;
  hasChange: boolean;
  disabled?: boolean;
}

const FilterChangeIcon: React.FC<FilterChangeIconProps> = React.forwardRef<
  HTMLDivElement,
  FilterChangeIconProps
>(({ title, tooltip, align, hasChange, disabled, ...divProps }, ref) => {
  const popoverContext = usePopoverContext();
  return (
    <VoxelTooltipShort message={tooltip} closeOnClick disabled={popoverContext.open}>
      <div
        className={`inline-block cursor-pointer ${popoverContext.open ? 'text-voxel-gray-900' : 'text-voxel-gray-500'
          } hover:text-voxel-gray-900`}
        {...divProps}
        ref={ref}
      >
        <div
          className={`flex flex-row flex-nowrap items-center group
      ${align === 'right' ? 'justify-end' : align === 'left' ? 'justify-start' : 'justify-center'}
      `}
        >
          {align == 'left' && <div className="whitespace-nowrap pr-1">{title}</div>}
          {!disabled && (
            <FontAwesomeIcon
              icon={faFilterRegular}
              className={
                hasChange
                  ? 'text-voxel-gray-700 group-hover:text-voxel-gray-600'
                  : 'text-voxel-gray-400/80 group-hover:opacity-90'
              }
            />
          )}
          {align !== 'left' && <div className="whitespace-nowrap pl-1">{title}</div>}
        </div>
      </div>
    </VoxelTooltipShort>
  );
});

export default FilterChangeIcon;
